<template>
    <div class="py-10 px-4">
        <v-container>
            <v-row>
                <v-col cols="12" lg="6">
                    <img :src="require('@/assets/images/logo.svg')" />

                    <div
                        class="mt-3 font-size-16 font-weight-600 text-blacknew"
                    >
                        {{ company_name }}
                    </div>

                    <div
                        class="mt-3 font-size-16 font-weight-400 text-blacknew"
                    >
                        {{ company_address }}
                    </div>

                    <div class="mt-8 d-flex align-center gap-10">
                        <a
                            v-for="(platform, i) in platforms"
                            :key="i"
                            class="link"
                            @click="openLink(platform.link)"
                        >
                            <img :src="platform.icon" />
                        </a>
                    </div>
                </v-col>

                <v-col cols="12" lg="6">
                    <v-row>
                        <v-col>
                            <div
                                class="font-size-16 font-weight-600 text-blacknew mb-5"
                            >
                                Skolla
                            </div>

                            <div
                                v-for="(menu, i) in menus"
                                :key="i"
                                class="mt-3"
                            >
                                <a
                                    class="link"
                                    @click="$router.push(menu.link)"
                                >
                                    {{ menu.text }}
                                </a>
                            </div>
                        </v-col>

                        <v-col>
                            <div
                                class="font-size-16 font-weight-600 text-blacknew mb-4"
                            >
                                Kontak
                            </div>

                            <div class="d-flex align-center gap-10">
                                <a
                                    v-for="(contact, i) in contacts"
                                    :key="i"
                                    class="link"
                                    @click="openLink(contact.link)"
                                >
                                    <img :src="contact.icon" />
                                </a>
                            </div>

                            <div
                                class="mt-5 font-size-16 font-weight-600 text-blacknew mb-4"
                            >
                                Ikuti Kami
                            </div>

                            <div class="d-flex align-center gap-10">
                                <a
                                    v-for="(follow, i) in follows"
                                    :key="i"
                                    class="link"
                                    @click="openLink(follow.link)"
                                >
                                    <img :src="follow.icon" />
                                </a>
                            </div>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>

<script>
export default {
    inject: ['display'],
    data() {
        return {
            company_name: 'PT. Teman Satu Skolla',
            company_address:
                'Jl. Mampang Prapatan X No.22, Tegal Parang, Jakarta Selatan, Daerah Khusus Ibukota Jakarta 12790',
            menus: [
                {
                    path: '/',
                    text: 'Paket Belajar',
                },
                {
                    path: '/cara-pembelian',
                    text: 'Cara Pembelian & Aktivasi',
                },
            ],

            platforms: [
                {
                    link: 'https://play.google.com/store/apps/details?id=com.skollaedutech.skolla&hl=id',
                    icon: require('@/assets/icons/playstore.svg'),
                },
                {
                    link: 'https://apps.apple.com/id/app/skolla-bimbel-sd-sma-utbk/id1576470654',
                    icon: require('@/assets/icons/appstore.svg'),
                },
                {
                    link: 'https://app.skolla.online/',
                    icon: require('@/assets/icons/webapp.svg'),
                },
            ],

            contacts: [
                {
                    link: 'https://wa.me/6285179519144?text=Halo, saya tertarik dengan aplikasi Skolla. Bisa dibantu?',
                    icon: require('@/assets/icons/btn-whatsapp.svg'),
                },
                {
                    link: 'mailto:hello@skolla.online',
                    icon: require('@/assets/icons/btn-email.svg'),
                },
                {
                    link: 'tel:+6285179519144',
                    icon: require('@/assets/icons/btn-telp.svg'),
                },
            ],

            follows: [
                {
                    link: 'https://www.instagram.com/skolla.online',
                    icon: require('@/assets/icons/btn-instagram.svg'),
                },
                {
                    link: 'https://www.tiktok.com/@skolla.online',
                    icon: require('@/assets/icons/btn-tiktok.svg'),
                },
                {
                    link: 'https://x.com/SkollaOnline',
                    icon: require('@/assets/icons/btn-twitter.svg'),
                },
                {
                    link: 'https://www.facebook.com/skolla.online',
                    icon: require('@/assets/icons/btn-facebook.svg'),
                },
                {
                    link: 'https://www.youtube.com/c/SkollaOnline',
                    icon: require('@/assets/icons/btn-youtube.svg'),
                },
                {
                    link: 'https://www.linkedin.com/company/skolla-edtech',
                    icon: require('@/assets/icons/btn-linkedin.svg'),
                },
            ],
        };
    },

    methods: {
        openLink(link) {
            window.open(link, '_blank');
        },
    },
};
</script>

<style>
.app-header {
    position: fixed;
    z-index: 10 !important;
    width: 100%;
    background-color: #fff;
}
</style>
